/**
 * Normalize a date-only value to local midnight, reading the calendar day from
 * the ISO `YYYY-MM-DD` prefix — immune to timezone shifts (a UTC-midnight date
 * must never render as the previous/next local day).
 */
const dateOnly = (value: string | Date): Date => {
  if (typeof value !== "string") {
    return new Date(value.getFullYear(), value.getMonth(), value.getDate());
  }
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(value);
  if (match) {
    return new Date(Number(match[1]), Number(match[2]) - 1, Number(match[3]));
  }
  return new Date(value);
};

/** Format a date string or Date as "10 jan. 2025" */
export const formatDateFR = (value: string | Date | null | undefined): string => {
  if (!value) return "—";
  const date = dateOnly(value);
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric",
  });
};

/** Format a date string or Date as "10/01/2025" (short numeric) */
export const formatDateShort = (value: string | Date | null | undefined): string => {
  if (!value) return "—";
  const date = dateOnly(value);
  return date.toLocaleDateString("fr-FR");
};

/** Format a date string or Date as "10 jan. 2025 à 14:30" */
export const formatDateTimeFR = (value: string | Date | null | undefined): string => {
  if (!value) return "—";
  const date = typeof value === "string" ? new Date(value) : value;
  return date.toLocaleDateString("fr-FR", {
    day: "numeric",
    month: "short",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};
